// @ts-strict-ignore
/* eslint-disable max-len */
import React, { useContext, useMemo, useState } from 'react';
import {
  Dropdown, DropdownToggle, DropdownMenu,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import {
  Avatar,
  AvatarRole,
  Icon,
  IconName,
} from '@usealloy/component-library';

import { UserContext } from '~/dashboard/context';
import { routes } from '~/helpers/routes';


function AccountDropdown() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => setDropdownOpen(prevState => !prevState);
  const {
    agent, customer, permissions, disableCustomerPicker,
  } = useContext(UserContext);
  const agentName = [agent.firstName, agent.lastName].filter(Boolean).join(' ');

  const isAdminPath = window.location.pathname.startsWith('/v3/dashboard/admin/');

  const agentRole = useMemo(() => {
    if (agent.isEmployee) {
      return AvatarRole.Alloy;
    }

    if (agent.adminAgentCustomerRole === 'Admin') {
      return AvatarRole.Admin;
    }

    if (agent.isAgent) {
      return AvatarRole.User;
    }

    return AvatarRole.Default;
  }, [agent]);

  const canAudit = (
    (
      customer.agentAuditEnabled
      && permissions['READ:AuditActions:null']
    ) || agent.isEmployee
  );

  return (
    <li className="dropdown dropright flex account-actions">
      <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} direction="left">
        <DropdownToggle className="dropdown-button">
          <Avatar name={agentName} role={agentRole} />
        </DropdownToggle>

        <DropdownMenu modifiers={{
          setMaxHeight: {
            enabled: true,
            fn: data => ({
              ...data,
              styles: {
                ...data.styles,
                overflow: 'auto',
                maxHeight: '400px',
              },
            }),
          },
        }}
        >
          {!disableCustomerPicker && agent.isAgent
            && agent.customerAgents.map(customerAgent => (
              customerAgent.customerId !== customer.customerId
              && customerAgent.customerAgentActive
              && !customerAgent.archived
              && (
                <a
                  key={`${customerAgent.customerId}-${customerAgent.customerAgentId}`}
                  className="flex no-wrap space align-start"
                  href={routes.switchCustomer(customerAgent.customerId)}
                >
                  <span>
                    {`Go to ${customerAgent.organizationName}${customerAgent.primaryAccount ? ' (primary)' : ''}`}
                  </span>
                  <Icon icon={IconName.ArrowsHorizontal} />
                </a>
              )))}

          {canAudit && !isAdminPath
            && (
              <Link className="flex no-wrap space align-start" to={routes.v3.dashboard.audit.list}>
                <span>Auditing</span>
                <Icon icon={IconName.Search} />
              </Link>
            )}
          <a
            className="flex no-wrap space align-start"
            href={`${window.location.origin}/logout`}
          >
            <span>Log out</span>
            <Icon icon={IconName.Power} />
          </a>

        </DropdownMenu>
      </Dropdown>
    </li>
  );
}

export default AccountDropdown;
